import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import { FC } from "react";
import SectionGridFilterCard from "./SectionGridFilterCard";
import { Helmet } from "react-helmet";

export interface ListingStayPageProps {
  className?: string;
}

const ListingStayPage: FC<ListingStayPageProps> = ({ className = "" }) => {
  return (
    <div
      className={`nc-ListingStayPage relative overflow-hidden ${className}`}
      data-nc-id="ListingStayPage"
    >
      <Helmet>
        <title>Special Flights - Flights Ticket Booking | My Flight Zone</title>
        <meta
          name="description"
          content="Find cheap flight tickets to travel to & from Sri Lanka. My Flight Zone offers affordable flights to Colombo, Sri Lanka ,Perth, Melbourne and more places."
        />
        <link rel="canonical" href="https://myflightzone.com.au/special-flights" />
      </Helmet>
      <BgGlassmorphism />

      <div className="container relative overflow-hidden">
        <SectionGridFilterCard className="pb-24 lg:pb-28" />
      </div>
    </div>
  );
};

export default ListingStayPage;
